import WSocket from './websocket'
import store from '../../store/index'
import {ResultCode} from '../request/index'

const namespace = 'WebSocket/'

const ws = new WSocket()
let heartInterval

function createHeartInterval () {
  if (heartInterval) {
    clearInterval(heartInterval)
  }
  heartInterval = setInterval(() => {
    console.log(' setInterval send')
    ws.send(JSON.stringify({message: 'heartbeat'}))
    // ws.send('{"code":"103","data":{"isLinked":1,"orderId":"584"}}')
  }, 10000)
}

// 为保持活跃 5秒请求一次
// send发送失败断开 会自动创建
ws.on('open', () => {
  console.log(' onopen')
  createHeartInterval()
})

ws.on('message', message => {
  // 接收到消息
  console.log(message)
  // 解析消息
  try {
    message = JSON.parse(message)
  } catch (err) {
    console.log('错误消息')
    return
  }

  // message.orderId = '11';
  console.log('message', message)
  if (message) {
    // //这个是跳转支付
    // if (message.orderId) {
    //   store.dispatch('goPay', message)
    //   return;
    // }
    // // 咨询人数
    // if (message.cumulativeNum) {
    //   store.commit(namespace + 'setPlatformMessage', message)
    //   return
    // }

    let methods
    switch (message.code) {
      // {"code":"101","data":{"sendCount":14,"orderId":3506}}
      case ResultCode.RC_NOTIFICATIONS_NUMBER:
        methods = 'setNotificationNumber'
        break
      // {"code":"102","data":{"field":"1,2,5","studio":"上海衡量律师事务所","name":"刘慧芳","imgs":"https://doc.51ljb.cn/headPicImg1532921348409"}}
      case ResultCode.RC_ORDER_LAWYER:
        methods = 'setOrderLawyer'
        store.commit(namespace + 'setHeartbeat')
        break
      // {"code":"103","data":{"isLinked":1,"orderId":"584"}}
      case ResultCode.RC_ORDER_OVER:
        store.dispatch(namespace + 'goPay', message.data)
        return
    }

    if (methods && message.data) {
      store.commit(namespace + methods, message.data)
    }
  }
})

ws.on('close', message => {
  console.log(' on close ', message)
  timeSend()
})

let timer
let errNum = 0

function timeSend () {
  if (timer) return
  timer = setTimeout(() => {
    ws.send(JSON.stringify({message: 'heartbeat'}))
    if (errNum === 5) { // 重试那么5-6次就放弃治疗吧
      // ws.stop();
    }
    errNum++
    timer = ''
  }, 3000)
}

ws.on('error', message => {
  console.log(' on error ', message)
  timeSend()
})

window.addEventListener('online', function (e) {
  ws.resetStop()
  ws.send(JSON.stringify({message: 'heartbeat'}))
})

window.addEventListener('offline', function (e) {
  console.log(' offline ', e)
  ws.send(JSON.stringify({message: 'heartbeat'}))
})

export default ws
export {
  ws
}



// WEBPACK FOOTER //
// ./src/libs/websocket/index.js